import { render, staticRenderFns } from "./vendor.vue?vue&type=template&id=6a857c3c&scoped=true&lang=html"
import script from "./vendor.vue?vue&type=script&lang=js"
export * from "./vendor.vue?vue&type=script&lang=js"
import style0 from "./vendor.vue?vue&type=style&index=0&id=6a857c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a857c3c",
  null
  
)

export default component.exports